import {Component, Inject, Input, OnInit, Optional} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {DeviceDetectService} from "../../services/device-detect.service";
import {SendingProgressUpdateService} from "../../services/sending-progress-update.service";
import {MatProgressBar} from "@angular/material/progress-bar";
import { NgClass } from "@angular/common";
import {MatIcon} from "@angular/material/icon";
import {environment} from "../../../environments/environment";
import {UserInfoService} from "../../services/user-info.service";

@Component({
  selector: "app-success-modal",
  templateUrl: "./success-modal.component.html",
  styleUrls: ["./success-modal.component.css"],
  imports: [
    MatProgressBar,
    TranslateModule,
    MatIcon,
    NgClass
]
})
export class SuccessModalComponent implements OnInit {
  @Input() message: {
    isSuccess: boolean,
    showErrorReport: boolean,
    isProgress?: boolean,
    title: string,
    description?: string,
    errorCode?: string
  };
  progressValue = 0;
  isMobile: boolean;
  sessionId: string = "";
  userPlatform: string = "";
  customerService = atob(environment.emails.customerService);

  constructor(
    private dialogRef: MatDialogRef<SuccessModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    public translateService: TranslateService,
    private deviceDetect: DeviceDetectService,
    private progressUpdateService: SendingProgressUpdateService,
    private userInfoService: UserInfoService
  ) {
    this.isMobile = this.deviceDetect.isMobile;
    this.message = this.data;
  }

  ngOnInit(): void {
    // Subscribes to progress updates and updates the progressValue property
    const sessionContext = this.userInfoService.getSessionContext();
    if (sessionContext === null) {
      this.sessionId = this.userInfoService.getSessionIdWhenNotLoggedIn();
    } else {
      this.sessionId = sessionContext.sessionId;
    }
    this.getUserPlatform();
    this.progressUpdateService.getProgressUpdates().subscribe((progress) => {
      this.progressValue = progress;
    });
  }

  onClose() {
    this.dialogRef.close();
  }

  getUserPlatform() {
    //doc: https://www.chromium.org/updates/ua-reduction/#reduced-navigatorplatform-values-for-all-versions
    switch (navigator.platform) {
      case "MacIntel": {
        this.userPlatform = (navigator.maxTouchPoints && navigator.maxTouchPoints > 1) ? "iPhone" : "macOS";
        break
      }
      case "Win32": {
        this.userPlatform = "Windows";
        break
      }
      case "Linux armv81": {
        this.userPlatform = "Android";
        break
      }
      case "Linux x86_64": {
        this.userPlatform = "Linux/Chrome OS";
        break
      }
      default: {
        this.userPlatform = navigator.platform;
        break
      }
    }
  }

  openTechnicalFeedbackEmail() {
    let subject: string;
    const body = "Error: " + this.translateService.instant(this.message.title) + "\nPlatform: " + this.userPlatform + "\nError code: " + this.message.errorCode;
    const technicalFeedback = this.translateService.instant("contactPage.technicalFeedback");
    const noId = this.translateService.instant("contactPage.noId");
    if (this.sessionId) {
      subject = `${technicalFeedback}${this.sessionId}`;
    } else {
      subject = `${technicalFeedback}${noId}`;
    }
    // Encode subject and body to be URL-safe
    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = encodeURIComponent(body);
    window.location.href = `mailto:${this.customerService}?subject=${encodedSubject}&body=${encodedBody}`;
  }

  showGpLink(description: string) {
    return ["SES-010", "SES-011"].includes(description);
  }
}
